import { FlagsMedusa } from "@/feature-flags/flags-misc-medusa";
// ./src/app/infrastructures/misc/common-library/SetViewportScale.ts

export function SetViewportScale(
  scale: number = FlagsMedusa.config_default_viewport_scale.getValue()
): void {
  document.documentElement.style.setProperty('--viewport-scale', `${scale}`);
}
